import { createStore } from "redux";
import State from "./model";
import reducer from "./reducer";
import { AppAction } from "./actions";
import * as ReactDOM from "react-dom";
import * as React from "react";
import { Provider } from "react-redux";
import DieSummaryDisplay from "./components/dieSummaryDisplay";
import RollDisplay from "./components/rollDisplay";
import ActionDisplay from "./components/actionDisplay";
import GameStatusDisplay from "./components/gameStatusDisplay";
import { Grid } from "react-bootstrap";
import undoable, { StateWithHistory } from "redux-undo";



var reducerWithUndo = undoable(reducer);

const store = createStore<StateWithHistory<State>, AppAction, {}, {}>(reducerWithUndo, (window as any).devToolsExtension && (window as any).devToolsExtension({}));

window.addEventListener('load', () => {
    ReactDOM.render(<Provider store={store}>
        <div>
            <GameStatusDisplay />
            <Grid className="entirePage">
                <DieSummaryDisplay />
                <ActionDisplay />
                <RollDisplay />
            </Grid>
        </div>
    </Provider>, document.getElementById("entirepage"));
});

